import React from 'react';

import { WithAccountPermitsChecker } from 'Controllers/AccountPermitsChecker/AccountPermitsChecker.helpers';
import proPropTypes from 'Utilities/proPropTypes';

import MoreMenu from '../MoreMenu/MoreMenu';

import styles from './MoreMenuComposer.module.scss';

const MoreMenuComposer = ({ permits, triggerSuccessToast }) => {
	const isMoreMenu = permits.displayMoreMenu();

	const handleOnClick = (e) => {
		e.preventDefault();
		e.stopPropagation();
	};

	if (!isMoreMenu) {
		return null;
	}

	return (
		<div className={styles.container} onClick={handleOnClick} role="presentation" tabIndex={-1}>
			<MoreMenu triggerSuccessToast={triggerSuccessToast} />
		</div>
	);
};

MoreMenuComposer.propTypes = {
	permits: proPropTypes.accountPermitsChecker.isRequired,
};

export default WithAccountPermitsChecker()(MoreMenuComposer);
